import React from 'react'
import { Block, Typography } from '@xprog/prensa'

type DropDownItemProps = {
  children?: any
  title?: string
}

export const ContainerHeader = ({ children, onClick }) => {
  return (
    <Block
      onClick={onClick}
      css={{
        align: ['row', 'between', 'middle'],
        borderBottom: '1px solid #E6E6E6',
        cursor: 'pointer',
        mt: '$4',
        mb: '$3',
        width: '100%',
      }}>
      {children}
    </Block>
  )
}
export const DropDownText = ({ children }) => {
  return (
    <Typography
      css={{
        color: '#4D4D4D',
        fontFamily: '$primary',
        fontWeight: 400,
        fontSize: '14px',
        lineHeight: '16.8px',
      }}>
      {children}
    </Typography>
  )
}
export const DropDownTitle = ({ children }) => {
  return (
    <Typography
      css={{
        color: '#000',
        fontFamily: '$primary',
        fontSize: '16px',
        lineHeight: '19.2px',
        fontWeight: 400,
      }}>
      {children}
    </Typography>
  )
}